import { useState, useEffect } from 'react'

export const useRelatedBreeds = (
  breedId: string | number | null | undefined
) => {
  const [relatedBreeds, setRelatedBreeds] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!breedId) {
      setRelatedBreeds([])
      return
    }

    const fetchRelatedBreeds = async () => {
      setLoading(true)
      setError(null)

      try {
        const request = await fetch(`/api/related-breeds/${breedId}`)
        const data = await request.json()

        if (data?.relatedBreeds) {
          setRelatedBreeds(data.relatedBreeds.slice(0, 10))
        } else {
          setRelatedBreeds([])
        }
      } catch (err) {
        setError(
          err instanceof Error
            ? err
            : new Error('Failed to fetch related breeds')
        )
        setRelatedBreeds([])
      } finally {
        setLoading(false)
      }
    }

    fetchRelatedBreeds()
  }, [breedId])

  return { relatedBreeds, loading, error }
}
